// import { useNavigate } from "react-router-dom";
// import { services } from "../../common/common";
// import { useCookies } from "react-cookie";
// import { config } from "../../config/config";
// import "../../styles/Services.css";

// const Service = () => {
//   const [cookies] = useCookies();
//   const navigate = useNavigate();
//   return (
//     <section className="services-section">
//       <div className="services-container">
//         <div className="services-header">
//           <span className="services-label">Our Services</span>
//           <h2 className="services-title">Complete Property Solutions</h2>
//           <p className="services-description">Discover our comprehensive range of property-related services</p>
//         </div>
//         <div className="services-grid" id="servicesGrid">
//           {services.map((item, index) => (
//             <div className="service-card" onClick={() => navigate(
//               item.navigate +
//               cookies[config.preferencesCookie]?.city.toLowerCase()
//             )}>
//               <div className="service-icon-container">
//                 {item.icon}
//                 {/* <i className="service-icon ${service.iconClassName}"></i> */}
//               </div>
//               <h3 className="service-title">{item.name}</h3>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section >
//   )
// }

// export default Service




















import React from "react";
import { useNavigate } from "react-router-dom";
import { services } from "../../common/common";
import { useCookies } from "react-cookie";
import { config } from "../../config/config";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Chip,
  IconButton
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import HandymanIcon from "@mui/icons-material/Handyman";

const Service = () => {
  const [cookies] = useCookies();
  const navigate = useNavigate();

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 4, sm: 5, md: 6 },
        backgroundColor: '#ffffff',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '1px',
          background: 'linear-gradient(90deg, transparent, #dc2626, transparent)',
        }
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3 } }}>
        {/* Header */}
        <Box sx={{ textAlign: "center", mb: { xs: 3, sm: 4, md: 5 } }}>
          <Chip
            icon={<HandymanIcon />}
            label="OUR SERVICES"
            sx={{
              backgroundColor: 'rgba(220, 38, 38, 0.1)',
              color: '#dc2626',
              fontWeight: 700,
              mb: 2,
              px: 2,
              py: 1,
              fontSize: { xs: '0.7rem', sm: '0.75rem' },
              letterSpacing: '0.5px',
              '& .MuiChip-icon': {
                color: '#dc2626',
                fontSize: { xs: '16px', sm: '18px' }
              }
            }}
          />

          <Typography
            variant="h2"
            sx={{
              fontWeight: 700,
              fontSize: { xs: "24px", sm: "30px", md: "36px" },
              color: '#111827',
              mb: 1,
              lineHeight: 1.2,
            }}
          >
            Complete Property{' '}
            <Box
              component="span"
              sx={{
                color: '#dc2626',
                position: 'relative',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: '2px',
                  left: 0,
                  width: '100%',
                  height: '4px',
                  backgroundColor: 'rgba(220, 38, 38, 0.1)',
                  borderRadius: '2px',
                }
              }}
            >
              Solutions
            </Box>
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: '#6b7280',
              fontSize: { xs: "14px", sm: "15px", md: "16px" },
              maxWidth: '600px',
              mx: 'auto',
              lineHeight: 1.6,
            }}
          >
            Discover our comprehensive range of property-related services tailored to your needs
          </Typography>
        </Box>

        {/* Services Grid */}
        <Grid container spacing={3}>
          {services.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
              <Card
                onClick={() => navigate(
                  item.navigate +
                  (cookies[config.preferencesCookie]?.city?.toLowerCase() || '')
                )}
                sx={{
                  height: '100%',
                  borderRadius: '16px',
                  border: '1px solid #f3f4f6',
                  background: 'white',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  position: 'relative',
                  overflow: 'hidden',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0 20px 40px rgba(220, 38, 38, 0.15)',
                    borderColor: '#dc2626',
                    '& .service-icon-container': {
                      transform: 'scale(1.1) rotate(5deg)',
                      backgroundColor: 'rgba(220, 38, 38, 0.1)',
                    },
                    '& .service-title': {
                      color: '#dc2626',
                    },
                    '& .hover-arrow': {
                      opacity: 1,
                      transform: 'translateX(0)',
                    },
                    '&::before': {
                      transform: 'translateX(0)',
                    }
                  },
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '3px',
                    backgroundColor: '#dc2626',
                    transform: 'translateX(-100%)',
                    transition: 'transform 0.4s ease',
                  }
                }}
              >
                <CardContent
                  sx={{
                    padding: { xs: '24px 20px', sm: '32px 24px' },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    height: '100%',
                  }}
                >
                  {/* Icon Container */}
                  <Box
                    className="service-icon-container"
                    sx={{
                      position: 'relative',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: { xs: '64px', sm: '72px', md: '80px' },
                      height: { xs: '64px', sm: '72px', md: '80px' },
                      backgroundColor: 'rgba(220, 38, 38, 0.05)',
                      borderRadius: '20px',
                      mb: 3,
                      transition: 'all 0.3s ease',
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        inset: '-4px',
                        backgroundColor: 'rgba(220, 38, 38, 0.1)',
                        borderRadius: '24px',
                        opacity: 0,
                        transition: 'opacity 0.3s ease',
                      },
                      '&:hover::before': {
                        opacity: 1,
                      }
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        height: '100%',
                        position: 'relative',
                        zIndex: 2,
                      }}
                    >
                      {item.icon && React.cloneElement(item.icon, {
                        sx: {
                          fontSize: { xs: 28, sm: 32, md: 36 },
                          color: '#dc2626',
                        }
                      })}
                    </Box>
                  </Box>

                  {/* Service Title */}
                  <Typography
                    className="service-title"
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      color: '#111827',
                      fontSize: { xs: '16px', sm: '18px' },
                      mb: 1,
                      transition: 'color 0.3s ease',
                    }}
                  >
                    {item.name}
                  </Typography>

                  {/* Service Description (if available) */}
                  {item.description && (
                    <Typography
                      variant="body2"
                      sx={{
                        color: '#6b7280',
                        fontSize: { xs: '13px', sm: '14px' },
                        lineHeight: 1.5,
                        mb: 2,
                      }}
                    >
                      {item.description}
                    </Typography>
                  )}

                  {/* Hover Arrow */}
                  <Box
                    className="hover-arrow"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 0.5,
                      mt: 'auto',
                      opacity: 0,
                      transform: 'translateX(-10px)',
                      transition: 'all 0.3s ease',
                    }}
                  >
                    <Typography
                      variant="caption"
                      sx={{
                        color: '#dc2626',
                        fontSize: '12px',
                        fontWeight: 600,
                        letterSpacing: '0.5px',
                      }}
                    >
                      Explore Service
                    </Typography>
                    <ArrowForwardIcon sx={{ fontSize: 14, color: '#dc2626' }} />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Services Count */}
        <Box sx={{ textAlign: 'center', mt: 4 }}>
          <Typography
            variant="body2"
            sx={{
              color: '#6b7280',
              fontSize: { xs: '13px', sm: '14px' },
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1,
            }}
          >
            <HandymanIcon sx={{ fontSize: { xs: 14, sm: 16 }, color: '#dc2626' }} />
            Offering {services.length} comprehensive property services
          </Typography>
        </Box>

        {/* CTA Button */}
        <Box sx={{ textAlign: 'center', mt: 5 }}>
          <IconButton
            onClick={() => navigate('/all-services')}
            sx={{
              backgroundColor: '#dc2626',
              color: 'white',
              borderRadius: '12px',
              padding: { xs: '12px 24px', sm: '14px 28px' },
              fontSize: { xs: '14px', sm: '16px' },
              fontWeight: 600,
              transition: 'all 0.3s ease',
              '&:hover': {
                backgroundColor: '#b91c1c',
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 24px rgba(220, 38, 38, 0.3)',
              },
              '& .MuiButton-startIcon': {
                mr: 1,
              }
            }}
          >
            View All Services
            <ArrowForwardIcon sx={{ ml: 1, fontSize: { xs: 18, sm: 20 } }} />
          </IconButton>
        </Box>
      </Container>
    </Box>
  );
};

export default Service;